/**
 * CMMS Theme - Unified Styling System
 * 
 * This unified theme system centralizes ALL CMMS-specific styling values
 * found across components to eliminate code duplication and ensure design consistency.
 */

export const cmmsTheme = {
  colors: {
    commentsBackground: '#E9F2F8',
    commentsText: '#0000008A',
    surfaceWhite: '#FFF',
    surfaceWhiteImportant: '#FFF !important',
    warningBackground: '#dc3545',
    excelGreen: '#217346',
  },

  spacing: {
    modalSection: '15px',
    inputOffset: '-2px',
    buttonOffset: '2px',
  },

  typography: {
    dialogTitle: {
      fontSize: '1.7em',
      fontWeight: 'bold' as const,
    },
    sectionTitle: {
      fontSize: 15,
      fontWeight: 'bold' as const,
    },
    semiBold: {
      fontWeight: 600,
    },
  },

  dimensions: {
    standardInput: '40px',
    textAreaMin: '80px',
  },

  styles: {
    commentsCard: {
      backgroundColor: '#E9F2F8',
    },
    
    commentsTitle: {
      fontSize: 15,
      fontWeight: 'bold' as const,
      color: '#0000008A',
    },
    
    dialogTitle: {
      fontSize: '1.7em',
      fontWeight: 'bold' as const,
    },
    
    filterSelect: {
      backgroundColor: '#FFF',
      height: '40px',
      marginTop: '-2px',
    },
    
    modalSection: {
      marginTop: '15px',
    },
    
    commentsTextArea: {
      height: '80px',
      border: 'none',
      backgroundColor: '#E9F2F8',
      fontSize: 16,
    },

    whiteBackgroundImportant: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#FFF !important',
        '&:hover': {
          backgroundColor: '#FFF !important',
        },
        '&.Mui-focused': {
          backgroundColor: '#FFF !important',
        },
      },
      '& .MuiSelect-select': {
        backgroundColor: '#FFF !important',
        '&:focus': {
          backgroundColor: '#FFF !important',
        },
      },
    },

    logbookTitleInput: {
      fontSize: '1.5em',
      fontWeight: 'bold' as const,
      '& .MuiInputBase-input': {
        padding: '0.5rem',
      },
    },

    logbookDatePicker: {
      width: '100%',
      '& .MuiInputBase-root': {
        height: '40px',
        paddingTop: 5,
      },
      '& .MuiOutlinedInput-root': {
        height: '40px',
      },
    },

    warningModal: {
      color: 'white',
      backgroundColor: '#dc3545',
      textAlign: 'center' as const,
    },

    // Fixed width, shared with pdfButton: the two are always shown as a pair and a ragged
    // right edge between them reads as a mistake.
    excelButton: {
      width: 110,
      height: 35,
      display: 'flex',
      justifyContent: 'center',
      padding: '0 14px',
      fontSize: 14,
      color: '#217346',
      border: '1px solid #217346',
      backgroundColor: '#FFF',
    },

    // Same box as excelButton, outlined the same way: the two are a pair of equivalent exports,
    // so neither should read as the primary action.
    pdfButton: {
      width: 110,
      height: 35,
      display: 'flex',
      justifyContent: 'center',
      padding: '0 14px',
      fontSize: 14,
      color: '#B30B00',
      border: '1px solid #B30B00',
      backgroundColor: '#FFF',
    },
  },
} as const;

export const useCmmsTheme = () => cmmsTheme;